import { render, staticRenderFns } from "./SetupProfileRow.vue?vue&type=template&id=8d4fb0da&scoped=true"
import script from "./SetupProfileRow.vue?vue&type=script&lang=js"
export * from "./SetupProfileRow.vue?vue&type=script&lang=js"
import style0 from "./SetupProfileRow.vue?vue&type=style&index=0&id=8d4fb0da&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4fb0da",
  null
  
)

export default component.exports